module.exports = __webpack_public_path__ + "img/caidanlan.193ed333.svg";